import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {Typeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import {FormGroup, Table, Button} from 'react-bootstrap';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';

const Config = require('../../../config');

class SuppliesOutputForm extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.addProduct = this.addProduct.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onSave = this.onSave.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);

		this.state = {
			output_date:"",
			user_send:"",
			national_center_id:"",
			specialty:"",
			person:"",
			observations:"",
			tbl_products:[],
			
			national_centers:[],
			specialties:[],
			product:"",
			products:[],
			lote:"",
			lotes:[],
			lote_name:"",
			amount:"",

			loading_center:false,
			nat_center_sel:[],
			index_center:-1,

			loading_special:false,
			special_sel:[],
			index_special:-1,

			loading_product:false,
			product_sel:[],
			index_product:-1,
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({national_centers:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=health_services&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({specialties:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'supplies_reagents/stock/'+
			sessionStorage.getItem('health_facilities_id'), {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({products:response});
			}
		});

		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			user_send:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});
		this.getTimeServer();
	}

	getTimeServer(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split('/').reverse().join('-')

			this.setState({
				output_date:date,
			});

		})
	}

	handleChange(e){
		var campo = e.target.name;
		this.setState({
			[campo]: e.target.value
		});

		if(campo === 'lote'){
			this.setState({
				lote_name:e.target.options[e.target.selectedIndex].text
			})
		}
		if(e.target.value !== ""){

			setTimeout(()=>{
				this.showCtrlError(campo);
			}, 300);
			
		}
	}

	handleTypeAheadChange = name => values => {

        if(values.length > 0){
        	if(name === 'product'){
        		this.setState({loading_product:true});

        		setTimeout(()=>{
        			this.setState({
						index_product:0,
						product_sel:values,
						product:values[0].product.id,
						lotes:values[0].stock,
						amount:1,
						loading_product:false,
				    });

				    this._typeahead_product.getInstance().blur();

				    this.errorAutoComplete('product');
        		}, 1000);
	        		
        	}else if(name === 'special'){
        		this.setState({loading_special:true});

        		setTimeout(()=>{
        			this.setState({
						index_special:0,
						special_sel:values,
						specialty:values[0].key,
						loading_special:false,
				    });

				    this._typeahead_special.getInstance().blur();

				    this.errorAutoComplete('special');
        		}, 1000);
	        		
        	}else if(name === 'center'){
        		this.setState({loading_center:true});

        		setTimeout(()=>{
        			this.setState({
						index_center:0,
						nat_center_sel:values,
						national_center_id:values[0].id,
						loading_center:false,
				    });

				    this._typeahead_center.getInstance().blur();

				    this.errorAutoComplete('center');
        		}, 1000);		
        	}
        }
    }

  	addProduct(e){
  		if(this.validate('details')){
  			var index = this.state.tbl_products.findIndex(obj => 
  				obj.product_id === this.state.product &&
  				obj.lote === this.state.lote
  			);

  			if(index === -1){
  				this.setState({
	  				tbl_products:[
	  					...this.state.tbl_products,
	  					{
	  						product_id:this.state.product,
	  						name:this.state.product_sel[0].product.name,
							amount:this.state.amount,
							lote:this.state.lote,
							lote_name:this.state.lote_name
	  					}
	  				],

	  				product:"",
					amount:"",
					loading_product:false,
					product_sel:[],
					index_product:-1,
					valid_prod:"",
					lote:"",
					lote_name:""
	  			});
  			}else{
  				swal('Error', 'El producto no puede tener el mismo lote', 'error');
  			}
  		}else{
  			swal('Error', 'Campos Incompletos', 'error');
  		}
  	}

  	validate(section){
  		const select = document.querySelector('div.'+section);
   		const inputs = select.querySelectorAll('input,select');
   		let isFormValid = true;

   		inputs.forEach(input => {
	    	if(input.required){

    			if(input.id === 'product'){
	    			isFormValid = this.errorAutoComplete('product');
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}   
		  	}
	    });
	    
	    return isFormValid;
  	}

  	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	errorAutoComplete(name){
		const length = name === 'product' ? this.state.product_sel.length :
						name === 'center' ? this.state.nat_center_sel.length :
						name === 'special' ? this.state.special_sel.length :  this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='product'){
				this.setState({valid_prod:'error'});
				isFormValid = false;
			}else if(name==='center'){
				this.setState({valid_nat:'error'});
				isFormValid = false;
			}else if(name==='special'){
				this.setState({valid_special:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='product'){
				this.setState({valid_prod:''});
			}else if(name==='center'){
				this.setState({valid_nat:''});
			}else if(name==='special'){
				this.setState({valid_special:''});
			}
		}
	
		return isFormValid;
	}

	onCancel(){
		this.props.history.push('/supplies_reagents/output');
	}

	onSave(){
		if(this.validate('entries')){
			var obj = {
				date:this.state.date !== "" ? moment(this.state.date).format('MM-DD-YYYY') : "",
				national_center_id:this.state.national_center_id,
				health_service:this.state.specialty,
				person_receives:this.state.person,
				observations:this.state.observations,
				supplies_export:[],
			};

			if(this.state.tbl_products.length > 0){
				this.state.tbl_products.map((t)=>{
					obj.supplies_export.push({
						supplies_id:t.product_id,
						lot_number:t.lote,
						amount:t.amount,
					})
				})
				this.props.waiting.handleShow('Guardando...');
				fetch(Config.default.apiGateway.URL+'supplies_exit/'+
					sessionStorage.getItem('health_facilities_id'), {
					method:'POST',
					body: JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Proceso Terminado', 'La salida se guardo correctamente', 'success');
						this.props.history.push('/supplies_reagents/output');
					}
				});

			}else{
				swal({
		          	title: "Error",
		          	text: 'Debe Ingresar por lo menos un producto',
		          	type: 'error',
		        }, (isConfirm)=>{
		            if (isConfirm) {
		            	setTimeout(()=>{
							this._typeahead_product.getInstance().focus();
		            	}, 500);
		             	
		            }else{
		              	return false;
		            }
		        });
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
		console.log(this.state)
	}

	removeUnitFromList = (indice) => {
		var array = [...this.state.tbl_products];
		array.splice(indice, 1);
		this.setState({tbl_products: array});
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Insumos ->
						Salidas  
					</h5>
				</div>

				<form noValidate>
					<fieldset className="col-xs-12">
						<legend>Salida</legend>
						<div className="col-xs-12 entries">
							<div className="col-xs-12"><span>(*) Campos Requeridos</span></div>
							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Fecha</span>
								<input type="date" className="form-control hour-input" name="entry_date" id="entry_date"
									value={this.state.output_date} onChange={this.handleChange}
									 disabled/>
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Usuario Envía</span>
								<input type="text" className="form-control" name="user_send" id="user_send"
									value={this.state.user_send} onChange={this.handleChange} disabled />
							</div>

							<div className="col-xs-12 col-sm-3">
								<FormGroup id="valid_nat" validationState={this.state.valid_nat || null} 
									style={{marginBottom:"0px"}}>
									<span className="span-min">Unidad Médica Solicita</span><span> (*)</span>
									<Typeahead
							          	labelKey={(option) => (`${option.name}`)}
							          	minLength={0}
							          	options={this.state.national_centers}
							          	onChange={this.handleTypeAheadChange('center')}	
							            inputProps={{
							          		name:"center",
							          		id:"center",
							          		autoComplete:"off",
							          		required:true
							          	}}
							          	id="auto_center"
							          	isLoading={this.state.loading_center}
							          	useCache={false}
							          	ref={ref => this._typeahead_center = ref}
							          	defaultSelected={this.state.national_centers.slice(this.state.index_center, 1)}
							          	selected={this.state.nat_center_sel}
							          	selectHintOnEnter={true}
							          	paginationText="Mostrar resultados adicionales"
							          	emptyLabel="No se encontraron resultados"
							          	searchText="Buscando..."
							          	promptText="Ingrese busqueda"
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-3">
								<FormGroup id="valid_special" validationState={this.state.valid_special || null} 
									style={{marginBottom:"0px"}}>
									<span className="span-min">Especialidad</span><span> (*)</span>
									<Typeahead
							          	labelKey={(option) => (`${option.name}`)}
							          	minLength={0}
							          	options={this.state.specialties}
							          	onChange={this.handleTypeAheadChange('special')}	
							            inputProps={{
							          		name:"special",
							          		id:"special",
							          		autoComplete:"off",
							          		required:true
							          	}}
							          	id="auto_special"
							          	isLoading={this.state.loading_special}
							          	useCache={false}
							          	ref={ref => this._typeahead_special = ref}
							          	defaultSelected={this.state.specialties.slice(this.state.index_special, 1)}
							          	selected={this.state.special_sel}
							          	selectHintOnEnter={true}
							          	paginationText="Mostrar resultados adicionales"
							          	emptyLabel="No se encontraron resultados"
							          	searchText="Buscando..."
							          	promptText="Ingrese busqueda"
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Persona Recibe</span>
								<input className="form-control" name="person" id="person" value={this.state.person}
									onChange={this.handleChange} />
							</div>

							<div className="col-xs-12">
								<span className="span-min">Observaciones</span>
								<input className="form-control" name="observations" id="observations" value={this.state.observations}
									onChange={this.handleChange} />
							</div>
							
						</div>
					</fieldset>

					<fieldset className="col-xs-12">
						<legend>Detalles</legend>
						<div className="col-xs-12 form-group details">
							<div className="col-xs-12 col-sm-2">
								<FormGroup id="valid_prod" validationState={this.state.valid_prod || null} 
									style={{marginBottom:"0px"}}>
									<span className="span-min">Insumo</span><span> (*)</span>
									<Typeahead
							          	labelKey={(option) => (`${option.product.name}`)}
							          	minLength={0}
							          	options={this.state.products.length > 0 ? this.state.products : []}
							          	onChange={this.handleTypeAheadChange('product')}	
							            inputProps={{
							          		name:"product",
							          		id:"product",
							          		autoComplete:"off",
							          		required:true
							          	}}
							          	id="auto_product"
							          	isLoading={this.state.loading_product}
							          	useCache={false}
							          	ref={ref => this._typeahead_product = ref}
							          	defaultSelected={this.state.products.slice(this.state.index_product, 1)}
							          	selected={this.state.product_sel}
							          	selectHintOnEnter={true}
							          	paginationText="Mostrar resultados adicionales"
							          	emptyLabel="No se encontraron resultados"
							          	searchText="Buscando..."
							          	promptText="Ingrese busqueda"
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Cantidad</span><span> (*)</span>
								<input type="number" className="form-control hour-input" name="amount" id="amount"
									value={this.state.amount} onChange={this.handleChange} 
									onKeyPress={this.blurInput} required/>
							</div>
							<div className="col-xs-12 col-sm-2">
								<span>Lote</span>
								<select className="form-control" name="lote" id="lote" value={this.state.lote}
									onChange={this.handleChange}>
									<option value="" total="0">Seleccione...</option>
									{this.state.lotes.map((l, i)=>(
										<option key={i} value={l.lot_number} total={l.total}>
											{l.lot_number}
										</option>
									))}
								</select>
							</div>
							<div className="col-xs-12 col-sm-1" style={{marginTop:'18px'}}>
								<FloatingActionButton iconStyle={{height: 25, width: 25}} className="action-btn" mini={true} onClick={this.addProduct} >
			                      <ContentAdd/>
			                    </FloatingActionButton> 
							</div>
						</div>

						<div className="col-xs-12">
							<Table responsive hover>
								<thead>
									<tr>
										<th>Insumo</th>
										<th>Cantidad</th>
										<th>Lote</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{this.state.tbl_products.map((t, i)=>(
										<tr key={i}>
											<td>{t.name}</td>
											<td>{t.amount}</td>
											<td>{t.lote}</td>
											<td>
												<Button className="btn btn-info btn-xs" title="Eliminar" 
													style={{marginRight:'3px'}} 
													onClick={(e) => this.removeUnitFromList(e, i)}>
						                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
						                        </Button>
											</td>
										</tr>
									))}
								</tbody>
							</Table>	
						</div>


					</fieldset>

					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
		        			style={{margin:12}} onClick={this.onCancel}/>
			        	
			        </div>
				</form>
			</div>
		)
	}

}

export default translate('translations')(SuppliesOutputForm);